(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency: window.Shopify?.currency?.active || 'EUR'}).format(cents/100);

  const header = $('[data-header]');
  const progress = $('[data-scroll-progress]');
  const updateScroll = () => {
    const y = window.scrollY;
    header?.classList.toggle('is-scrolled', y > 24);
    if (progress) {
      const max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
      progress.style.transform = `scaleX(${Math.min(1, y / max)})`;
    }
  };
  addEventListener('scroll', updateScroll, {passive:true}); updateScroll();

  // Word reveal without clipping glyphs.
  $$('[data-word-reveal]').forEach(el => {
    const nodes = [...el.childNodes];
    nodes.forEach(node => {
      if (node.nodeType !== Node.TEXT_NODE || !node.textContent.trim()) return;
      const frag = document.createDocumentFragment();
      const parts = node.textContent.split(/(\s+)/);
      let idx = 0;
      parts.forEach(part => {
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        const outer = document.createElement('span'); outer.className='sp-word';
        const inner = document.createElement('span'); inner.className='sp-word__inner'; inner.style.setProperty('--wi', idx++); inner.textContent=part;
        outer.appendChild(inner); frag.appendChild(outer);
      });
      node.replaceWith(frag);
    });
  });

  const io = new IntersectionObserver(entries => entries.forEach(e => {
    if (e.target.hasAttribute('data-reveal')) e.target.classList.toggle('is-visible', e.isIntersecting);
    if (e.target.hasAttribute('data-word-reveal')) e.target.classList.toggle('is-word-visible', e.isIntersecting);
    if (e.target.hasAttribute('data-scene')) e.target.classList.toggle('is-active', e.isIntersecting);
  }), {threshold:.16, rootMargin:'0px 0px -5%'});
  $$('[data-reveal],[data-word-reveal],[data-scene]').forEach(el => io.observe(el));

  // Product image parallax / tilt.
  const stage = $('[data-product-stage]');
  const stageImg = stage?.querySelector('.sp-product-stage__image');
  if (stage && stageImg && matchMedia('(hover:hover)').matches) {
    stage.addEventListener('pointermove', e => {
      const r=stage.getBoundingClientRect(), x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
      stageImg.style.transform=`rotateY(${x*8}deg) rotateX(${-y*7}deg) translate3d(${x*9}px,${y*9}px,0)`;
    });
    stage.addEventListener('pointerleave',()=>stageImg.style.transform='');
  }

  // Magnetic buttons.
  if (matchMedia('(hover:hover)').matches) $$('.sp-magnetic').forEach(el => {
    el.addEventListener('pointermove', e => { const r=el.getBoundingClientRect(), x=e.clientX-(r.left+r.width/2), y=e.clientY-(r.top+r.height/2); el.style.transform=`translate(${x*.08}px,${y*.10}px)`; });
    el.addEventListener('pointerleave',()=>el.style.transform='');
  });

  // Cursor glow and occasional sparks at speed.
  const glow=$('.sp-cursor-glow'), dot=$('.sp-cursor-dot'); let lastX=0,lastY=0,lastT=performance.now();
  if (glow && dot && matchMedia('(hover:hover)').matches) {
    addEventListener('pointermove', e => {
      glow.style.left=e.clientX+'px'; glow.style.top=e.clientY+'px'; dot.style.left=e.clientX+'px'; dot.style.top=e.clientY+'px';
      const now=performance.now(), dt=Math.max(1,now-lastT), speed=Math.hypot(e.clientX-lastX,e.clientY-lastY)/dt;
      if(speed>1.25 && Math.random()>.7){ const s=document.createElement('i'); s.className='sp-spark'; s.style.left=e.clientX+'px'; s.style.top=e.clientY+'px'; s.style.setProperty('--sx',`${(Math.random()-.5)*34}px`); s.style.setProperty('--sy',`${(Math.random()-.5)*34}px`); document.body.appendChild(s); setTimeout(()=>s.remove(),750); }
      lastX=e.clientX;lastY=e.clientY;lastT=now;
    },{passive:true});
    $$('a,button,select,input,summary').forEach(el=>{el.addEventListener('pointerenter',()=>dot.classList.add('is-hot'));el.addEventListener('pointerleave',()=>dot.classList.remove('is-hot'))});
  }

  // Quantity.
  $$('[data-qty]').forEach(q => {
    const input=$('input',q); $('[data-qty-minus]',q)?.addEventListener('click',()=>input.value=Math.max(1,(parseInt(input.value)||1)-1)); $('[data-qty-plus]',q)?.addEventListener('click',()=>input.value=(parseInt(input.value)||1)+1);
  });

  // Variant price updates.
  $$('[data-variant-select]').forEach(sel=>sel.addEventListener('change',()=>{ const opt=sel.selectedOptions[0]; const price=$('[data-product-price]'); if(price && opt?.dataset.price) price.textContent=opt.dataset.price; }));

  // Compact legal footer: keep the imprint available without a large legal block on the product page.
  const imprintDialog = $('[data-imprint-dialog]');
  $('[data-imprint-open]')?.addEventListener('click', () => {
    if (!imprintDialog) return;
    if (typeof imprintDialog.showModal === 'function') imprintDialog.showModal();
    else imprintDialog.setAttribute('open', '');
  });
  $('[data-imprint-close]')?.addEventListener('click', () => imprintDialog?.close?.());
  imprintDialog?.addEventListener('click', e => {
    if (e.target === imprintDialog) imprintDialog.close?.();
  });

  // Preorder goal counter: inventory is used as the number of remaining preorder slots.
  // It refreshes while the tab is open so new completed orders can appear without a manual reload.
  const goalCounter = $('[data-goal-counter]');
  if (goalCounter?.dataset.counterLive === 'true') {
    let counterBusy = false;
    const refreshGoalCounter = async () => {
      if (counterBusy || document.hidden) return;
      const sectionId = goalCounter.dataset.sectionId;
      if (!sectionId) return;
      counterBusy = true;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', sectionId);
        url.searchParams.set('_spcounter', Date.now().toString());
        const response = await fetch(url.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-goal-counter]');
        if (!fresh) return;
        if (fresh.dataset.sold !== goalCounter.dataset.sold || fresh.dataset.remaining !== goalCounter.dataset.remaining) {
          goalCounter.innerHTML = fresh.innerHTML;
          goalCounter.dataset.sold = fresh.dataset.sold || '';
          goalCounter.dataset.remaining = fresh.dataset.remaining || '';
          goalCounter.classList.toggle('is-complete', fresh.classList.contains('is-complete'));
          goalCounter.classList.remove('sp-counter-pulse');
          void goalCounter.offsetWidth;
          goalCounter.classList.add('sp-counter-pulse');
          setTimeout(() => goalCounter.classList.remove('sp-counter-pulse'), 900);
        }
      } catch (_) {
        // Keep the last valid server-rendered count if refresh is temporarily unavailable.
      } finally {
        counterBusy = false;
      }
    };
    setInterval(refreshGoalCounter, 30000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshGoalCounter(); });
  }
})();
